import { render, staticRenderFns } from "./publicJournal.vue?vue&type=template&id=8ab6337c&"
import script from "./publicJournal.vue?vue&type=script&lang=js&"
export * from "./publicJournal.vue?vue&type=script&lang=js&"
import style0 from "./publicJournal.vue?vue&type=style&index=0&id=8ab6337c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports